import script from "./Post.vue?vue&type=script&lang=ts&setup=true"
export * from "./Post.vue?vue&type=script&lang=ts&setup=true"

import "./Post.vue?vue&type=style&index=0&id=619b4fdf&scoped=true&lang=scss"
import "./Post.vue?vue&type=style&index=1&id=619b4fdf&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619b4fdf"]])

export default __exports__